









































import {Component, Prop, Vue} from 'vue-property-decorator';
import {PortfolioCompany} from '@/store/models';

@Component
export default class PortfolioCompanyItem extends Vue {
    @Prop() company: PortfolioCompany | undefined;
}
